import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureLoanTransferAccountSummary(props) {
    return <AccountSummaryPage />
}